import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const ArrowDown = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 18 18">
      <g clipPath="url(#clip0_1044_2782)">
      <path fillRule="evenodd" clipRule="evenodd" d="M16.3231 5.04965C15.9526 4.68365 15.3511 4.68365 14.9798 5.04965L9.00006 10.9574L3.02031 5.04965C2.64906 4.68365 2.04756 4.68365 1.67631 5.04965C1.30581 5.4164 1.30581 6.0104 1.67631 6.37715L8.32806 12.9486C8.69856 13.3146 9.30006 13.3146 9.67131 12.9486L16.3223 6.37715C16.5083 6.19415 16.6013 5.95415 16.6013 5.7134C16.6013 5.47265 16.5091 5.2334 16.3231 5.04965Z" fill="#C72037"/>
      </g>
      <defs>
      <clipPath id="clip0_1044_2782">
      <rect width="18" height="18" fill="white"/>
      </clipPath>
      </defs> 
    </SvgIcon>
  );
}

export default ArrowDown;